// src/pages/auth/UpdatePassword.js
import React from "react";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

import { Paper, Typography } from "@mui/material";

import { ReactComponent as Logo } from "../../vendor/logo.svg";
import UpdatePasswordComponent from "../../components/auth/UpdatePassword";

const Brand = styled(Logo)`
  fill: ${(props) => props.theme.palette.primary.main};
  width: 64px;
  height: 64px;
  margin-bottom: 32px;
`;

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

function UpdatePassword() {
  return (
    <React.Fragment>
      <Link to="/">
        <Brand />
      </Link>
      <Wrapper>
        <Helmet title="Update Password" />

        <Typography component="h1" variant="h4" align="center" gutterBottom>
          Update Password
        </Typography>
        <Typography component="h2" variant="body1" align="center">
          Enter your new password
        </Typography>

        <UpdatePasswordComponent />
      </Wrapper>
    </React.Fragment>
  );
}

export default UpdatePassword;
